<script setup>
import { onMounted, inject, nextTick, ref } from "vue"
import { router } from "@inertiajs/vue3"
import { Swiper, SwiperSlide } from "swiper/vue"
import { Autoplay, EffectFade } from "swiper/modules"

const modules = [Autoplay, EffectFade]
const gsap = inject("gsap")
const ScrollTrigger = inject("ScrollTrigger")
const parallaxSection = ref(null)
router.on("navigate", e => {
	// initParallax()
})

const initParallax = () => {
	nextTick(() => {
		console.log("MOUNTED", document.querySelector(".parallax-banner"))
		ScrollTrigger.create({
			trigger: document.querySelector(".parallax-banner"),
			start: "top top",
			pin: true,
			pinSpacing: false
		})
	})
}

const props = defineProps({
	item: {
		type: Object
	},
	items: {
		type: Array,
		default: () => []
	}
})
</script>

<template>
	<swiper
		v-if="items.length > 0"
		ref="parallaxSection"
		:autoplay="{ delay: 5000 }"
		:effect="'fade'"
		:loop="true"
		:modules="modules"
		:scrollbar="{ draggable: true }"
		:slides-per-view="1"
		:space-between="0"
		class="swiper-primary parallax-banner"
	>
		<swiper-slide v-for="(slide, i) in items" :key="i">
			<div :style="`background-image: url(/storage/${slide.cover})`" class="w-container relative flex h-[300px] w-full items-end bg-cover bg-center bg-no-repeat md:h-screen">
				<div class="absolute inset-0 z-20 bg-gradient-to-t from-black/40 to-transparent"></div>
				<div class="relative z-30 pb-7 md:pb-32">
					<p v-if="slide.subtitle" class="left-line light text-base font-semibold text-white md:text-xl">
						{{ slide.subtitle }}
					</p>
					<a
						v-if="slide.title"
						:href="slide.url === null ? route('page.thought', slide.slug) : slide.url"
						class="font-heading inline-block max-w-4xl text-2xl font-semibold text-white underline md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl"
					>
						{{ slide.title }}
					</a>
				</div>
			</div>
		</swiper-slide>
	</swiper>
	<section v-if="item">
		<div
			ref="parallaxSection"
			:style="`background-image: url(/storage/${item.image})`"
			class="parallax-banner w-container relative flex h-[300px] w-full items-end bg-cover bg-center bg-no-repeat md:h-screen"
		>
			<div class="absolute inset-0 z-20 bg-gradient-to-t from-black/40 to-transparent"></div>
			<div class="relative z-30 pb-7 md:pb-32">
				<p v-if="item.subtitle" class="left-line light font-semibold text-white md:text-xl">{{ item.subtitle }}</p>
				<p v-if="item.title" class="font-heading inline-block max-w-4xl text-2xl font-semibold text-white underline md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl">
					{{ item.title }}
				</p>
			</div>
		</div>
	</section>
</template>

<style lang="scss" scoped></style>
